import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import Tools from "./pages/Tools";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Guide from "./pages/Guide";
import ToolMindDeck from "./pages/ToolMindDeck";
import ToolJsonParser from "./pages/ToolJsonParser";

const App = () => {
    return (
        <ThemeProvider>
            <LanguageProvider>
                <Router>
                    <Routes>
                        <Route path="/" element={<Layout />}>
                            <Route index element={<Home />} />
                            <Route path="tools" element={<Tools />} />
                            <Route
                                path="tools/minddeck"
                                element={<ToolMindDeck />}
                            />
                            <Route
                                path="tools/json-parser"
                                element={<ToolJsonParser />}
                            />
                            <Route path="about" element={<About />} />
                            <Route path="contact" element={<Contact />} />
                            <Route path="privacy" element={<Privacy />} />
                            <Route path="terms" element={<Terms />} />
                            <Route path="guide" element={<Guide />} />
                            {/* 추가 라우트들은 여기에 */}
                        </Route>
                    </Routes>
                </Router>
            </LanguageProvider>
        </ThemeProvider>
    );
};

export default App;
